import { useContext, useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom';
import ScrollToTop from 'react-scroll-to-top';
import { AppContext } from '../../contexts/App';
import CIcon from '@coreui/icons-react';
import { cilArrowTop, cilPlus, cisChevronBottom, cisChevronTop } from '@coreui/icons-pro';
import FilterSorting from './componenet.filter.sorting';
import Table from './componenet.table';
import {CButton, CCard, CCardBody, CCardHeader, CCol, CCollapse, CRow} from "@coreui/react-pro";

const Index = () => {
    const { setMetaData, theme } = useContext(AppContext)
    const [searchParams] = useSearchParams();
    const navigate = useNavigate()
    const [collapseFilterSorting, setCollapseFilterSorting] = useState(searchParams.has('date_after') ||
        searchParams.has('date_before')
    )

    useEffect(() => {
        setMetaData({
            title: "Template"
        })
    }, [setMetaData])

    return (<>
        <CRow>
            <CCol md={12}>
                <CButton color={'primary'} size='sm' className='me-2 mb-3' onClick={() => {
                    navigate({ pathname: "add" })
                }}><CIcon icon={cilPlus} className='me-1' />Add</CButton>
                <CButton active={collapseFilterSorting} color={collapseFilterSorting ? 'dark' : 'primary'} size='sm' className='me-2 mb-3' onClick={() => {
                    setCollapseFilterSorting(x => !x)
                }}> Filter <CIcon className='ms-1' icon={collapseFilterSorting ? cisChevronBottom : cisChevronTop} /></CButton>

            </CCol>
        </CRow>
        <CCollapse visible={collapseFilterSorting}>
            <CRow className='mb-3'>
                <CCol>
                    <CCard>
                        <CCardHeader>
                            Filter & Sorting
                        </CCardHeader>
                        <CCardBody>
                            <FilterSorting />
                        </CCardBody>
                    </CCard>
                </CCol>
            </CRow>
        </CCollapse>
        <CRow>
            <CCol>
                <CCard>
                    <CCardBody>
                        <Table />
                    </CCardBody>
                </CCard>
            </CCol>
        </CRow>
        <ScrollToTop smooth component={<CIcon icon={cilArrowTop} />} className={`rounded-circle bg-${theme}`} />
    </>)
}

export default Index